<template>
  <TablePermissionAction />
</template>
<script>
import TablePermissionAction from "./components/tablePermissionAction";
export default {
  components: {
    TablePermissionAction,
  },
  methods: {},
  created() {},
};
</script>
<style></style>
